import { useCallback, useMemo } from 'react';

import { useAppAlert } from '@Components/AppAlert';
import { useDefaultEvents, useGrid } from '@Components/Grid';

export default function useEvents() {
  const { handleDeleteEntry, handleUpdateEntry } = useDefaultEvents()
  const { store: { reorder }, handleRefresh, definitions } = useGrid()
  const { handleSuccess, handleError } = useAppAlert()
  const { entityName } = definitions || {}

  const handleUpdateEntries = useCallback(async rows => {
    try {
      await reorder(rows.map(({ original }) => original))
      handleRefresh()
      handleSuccess('Success', `${entityName} edited.`)
    } catch (e) {
      handleError('Error', `${entityName} was not saved.`)
    }
  }, [reorder, handleRefresh, handleSuccess, handleError, entityName])

  return useMemo(() => ({
    handleUpdateEntry,
    handleDeleteEntry,
    handleUpdateEntries,
  }), [handleUpdateEntry, handleDeleteEntry, handleUpdateEntries])
}
